"use client";;
import { cn } from "@/lib/utils";
import { motion } from "motion/react";
import { memo, useMemo } from "react";

const ShimmerComponent = ({
    children,
    as: Component = "p",
    className,
    duration = 2,
    spread = 2
}) => {
    const MotionComponent = motion.create(Component);

    const dynamicSpread = useMemo(() => (children?.length ?? 0) * spread, [children, spread]);

    return (
        <MotionComponent
            animate={{ backgroundPosition: "0% center" }}
            className={cn(
                "relative inline-block bg-[length:250%_100%,auto] bg-clip-text text-transparent",
                "[--bg:linear-gradient(90deg,transparent_calc(50%-var(--spread)),hsl(var(--foreground))_50%,transparent_calc(50%+var(--spread)))] [background-repeat:no-repeat,padding-box]",
                className
            )}
            initial={{ backgroundPosition: "100% center" }}
            style={
                {
                    "--spread": `${dynamicSpread}px`,

                    backgroundImage:
                        "var(--bg), linear-gradient(hsl(var(--muted-foreground)), hsl(var(--muted-foreground)))"
                }
            }
            transition={{
                repeat: Number.POSITIVE_INFINITY,
                duration,
                ease: "linear",
            }}>
            {children}
        </MotionComponent>
    );
};

export const Shimmer = memo(ShimmerComponent);
